var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRrDashboardOngoing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 33,
    viewBox: "0 0 53 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1512 25.1531C43.8626 25.1531 46.0607 22.9551 46.0607 20.2436C46.0607 17.5322 43.8626 15.3342 41.1512 15.3342C38.4397 15.3342 36.2417 17.5322 36.2417 20.2436C36.2417 22.9551 38.4397 25.1531 41.1512 25.1531Z",
    stroke: "#0BB7A7",
    strokeWidth: 0.981896,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1507 17.298V20.2437H38.9414",
    stroke: "#0BB7A7",
    strokeWidth: 0.981896,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2706 26.6599C45.7982 28.0849 43.8695 28.9434 41.8254 29.0838C39.7812 29.2242 37.7532 28.6375 36.0998 27.4273C34.4464 26.2171 33.2741 24.4613 32.79 22.4703C32.3059 20.4794 32.5413 18.3813 33.4545 16.5471C34.3676 14.7129 35.8999 13.2605 37.7803 12.4467",
    stroke: "#0BB7A7",
    strokeWidth: 1.51061,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4803 10.9181L39.3661 11.7206L38.6322 14.3594",
    stroke: "#0BB7A7",
    strokeWidth: 1.45716,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4168 12.4204C46.3303 13.1531 47.9232 14.5386 48.9139 16.3321C49.9047 18.1256 50.2295 20.2117 49.831 22.2215",
    stroke: "#0BB7A7",
    strokeWidth: 1.51061,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.02 3.02"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.19397 32.7483V0.385498H40.6475V8.52156C39.9529 8.58416 39.2767 8.71061 38.6248 8.89499V8.4762H2.21665V30.7256H38.6248V30.3068C39.2767 30.4912 39.9529 30.6177 40.6475 30.6803V32.7483H0.19397ZM31.7473 24.6576C32.1172 25.3813 32.5641 26.0591 33.0771 26.6803H21.4321V24.6576H31.7473ZM38.6248 2.40817H2.21665V6.45353H38.6248V2.40817ZM10.2876 11.3917L12.1878 10.7004L18.4139 27.8062L16.5137 28.5015L10.2876 11.3917ZM6.262 16.5669V14.5442H8.28468V16.5669H6.262ZM6.262 24.6576V22.6349H8.28468V24.6576H6.262Z",
    fill: "#0BB7A7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4435 19.6009H28.5115",
    stroke: "#0BB7A7",
    strokeWidth: 2.02268,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRrDashboardOngoing);
export default __webpack_public_path__ + "static/media/rr_dashboard_ongoing.1f7b7964d14fd23bd75061e79944e4c3.svg";
export { ForwardRef as ReactComponent };